module.exports = __webpack_public_path__ + "static/img/2areaA_25.6066ec7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/2areaA_25.png
// module id = 901
// module chunks = 1